interface IPolicyLossFile {
	dataString: string | null;
	type: string | null;
	name: string | null;
}

export default class PolicyLossFile {

	public dataString: string | null = null;
	public type: string | null = null;
	public name: string | null = null;

	public constructor(policyLossFile: IPolicyLossFile) {
		this.dataString = policyLossFile.dataString;
		this.type = policyLossFile.type;
		this.name = policyLossFile.name;
	}
};